export default __webpack_public_path__ + "8e2f855f9da4f5b1b4f10886e597917e.webp";